import React from 'react';
import { Municipality, getFeesForYear, getYearOverYearChange, filterFees, DEFAULT_ENABLED_CATEGORIES } from '@/lib/data';

interface CompactWidgetProps {
  municipalities: Municipality[];
  year: number;
  limit?: number;
  enabledCategories?: string[];
  dark?: boolean;
}

const getChangeClass = (change: number, dark?: boolean) => {
  if (change > 0) return dark ? 'text-amber-400' : 'text-amber-600';
  if (change < 0) return dark ? 'text-slate-400' : 'text-slate-600';
  return dark ? 'text-slate-500' : 'text-warmGray';
};

export const CompactWidget: React.FC<CompactWidgetProps> = ({
  municipalities,
  year,
  limit = 4,
  enabledCategories = DEFAULT_ENABLED_CATEGORIES,
  dark,
}) => {
  const data = municipalities
    .map(m => ({
      m,
      total: filterFees(getFeesForYear(m, year), enabledCategories).reduce((s, f) => s + f.amount, 0),
      change: getYearOverYearChange(m, year, enabledCategories),
    }))
    .filter(x => x.total > 0)
    .sort((a, b) => b.total - a.total)
    .slice(0, limit);

  return (
    <div className={`py-3 ${dark ? 'text-slate-300' : ''}`}>
      <p className="text-sm leading-relaxed">
        {data.map(({ m, total, change }, i) => (
          <span key={m.id}>
            <span className={dark ? 'text-white' : 'text-deepCharcoal'}>{m.name}</span>
            {' '}
            {change !== null && (
              <span className={getChangeClass(change, dark)}>
                ({change > 0 ? '+' : ''}{change.toFixed(1)}%)
              </span>
            )}
            {' '}
            <span className={dark ? 'text-slate-400' : 'text-nordicBlue'}>
              {total.toLocaleString('nb-NO')} kr
            </span>
            {i < data.length - 1 && <span className="mx-2 text-warmGray">·</span>}
          </span>
        ))}
      </p>
    </div>
  );
};
